import { compose } from 'lodash/fp'
import { isObjectLike } from 'lodash'
import React from 'react'
import {
  ITagsForEvents,
  ITagsForEventsWithPreferences,
} from '../../../reducers/userObject/tags'
import { Input } from '../elements'
import FormElement from '../FormElement'
import withReduxForm from '../withReduxForm'
import { default as TagIn, ITag, ITagInputProps } from './TagInput'
import withRedux from './withRedux'

export function mapStringToTags(
  tagString = '',
  tagsList: ITagsForEvents & ITagsForEventsWithPreferences,
): (ITag | string)[] {
  const tags = tagString
    .split(/(#.*?#)/)
    .map(Function.prototype.call, String.prototype.trim)
    .map(tag => (tag in tagsList ? { ...tagsList[tag], key: tag } : tag))

  return tags[tags.length - 1] === '' ? tags.slice(0, -1) : tags
}

export function mapTagsToString(tagArray: (ITag | string)[]): string {
  return tagArray
    .map(element => (isObjectLike(element) ? (element as ITag).key : element))
    .join(' ')
}

function ensureTagFirst(
  tagArray: (ITag | string)[],
  tagKey?: string,
): (ITag | string)[] {
  if (!tagKey) return tagArray

  const index = tagArray.findIndex(tag =>
    isObjectLike(tag) ? (tag as ITag).key === tagKey : String(tag) === tagKey,
  )

  if (index <= 0) return tagArray

  const copy = [...tagArray]
  const [pinnedTag] = copy.splice(index, 1)
  copy.unshift(pinnedTag)

  return copy
}

const TagInput = FormElement(
  ({
    name,
    onChange,
    value,
    tagsList,
    className,
    size = 1,
    disabled = false,
    pinFirstTagKey,
  }: ITagInputProps) => {
    function onTagInputChange(tags) {
      onChange(mapTagsToString(ensureTagFirst(tags, pinFirstTagKey)))
    }

    return (
      <React.Fragment>
        <Input
          style={{ display: 'none' }}
          name={name}
          type={'text'}
          disabled={disabled}
          onChange={onChange}
          value={value}
          className={className}
        />
        <TagIn
          disabled={disabled}
          size={size}
          tagsList={tagsList}
          value={value}
          onChange={onTagInputChange}
          className={className}
        />
      </React.Fragment>
    )
  },
)

export default compose(
  withReduxForm,
  withRedux,
)(TagInput)
export { TagInput }
